import type { Match } from '@/data/types';

/**
 * Возвращает Map: participantId → сумма очков всех его соперников.
 * Очко = 1 за победу в сыгранном матче (включая bye).
 */
export function computeBuchholz(matches: Match[], participantIds: string[]): Map<string, number> {
  // Сначала считаем очки каждого
  const points = new Map<string, number>();
  for (const id of participantIds) points.set(id, 0);
  for (const m of matches) {
    if (m.status !== 'COMPLETED' || !m.score) continue;
    points.set(m.score.winnerId, (points.get(m.score.winnerId) ?? 0) + 1);
  }

  // Список соперников
  const opponents = new Map<string, string[]>();
  for (const id of participantIds) opponents.set(id, []);
  for (const m of matches) {
    if (m.status !== 'COMPLETED') continue;
    if (m.playerAId && m.playerBId) {
      // Снятый участник может отсутствовать в participantIds — безопасный доступ.
      opponents.get(m.playerAId)?.push(m.playerBId);
      opponents.get(m.playerBId)?.push(m.playerAId);
    }
  }

  const buchholz = new Map<string, number>();
  for (const id of participantIds) {
    const ops = opponents.get(id) ?? [];
    let sum = 0;
    for (const op of ops) sum += points.get(op) ?? 0;
    buchholz.set(id, sum);
  }
  return buchholz;
}
